import {
  LOAD_PROPOSALS,
  CANCEL_PROPOSAL,
  CANCEL_PROPOSAL_SUCCESS,
  CANCEL_PROPOSAL_ERROR,
  LOAD_PROPOSALS_ERROR,
  LOAD_PROPOSALS_SUCCESS,
  CANCEL_NEW_OPERATIONS_PROPOSAL,
  CANCEL_NEW_OPERATIONS_PROPOSAL_SUCCESS,
  CANCEL_NEW_OPERATIONS_PROPOSAL_ERROR
} from '../constants/proposals';

export const LoadProposals = payload => ({
  type: LOAD_PROPOSALS,
  payload,
});

export const LoadProposalsSuccess = ({ proposals, filters }) => ({
  type: LOAD_PROPOSALS_SUCCESS,
  proposals,
  filters
});

export const LoadProposalsError = () => ({
  type: LOAD_PROPOSALS_ERROR,
});

export const CancelProposal = proposalId => ({
  type: CANCEL_PROPOSAL,
  proposalId,
});

export const CancelNewOperationsProposal = proposalId => ({
  type: CANCEL_NEW_OPERATIONS_PROPOSAL,
  proposalId,
});

export const CancelNewOperationsProposalSuccess = proposalId => ({
  type: CANCEL_NEW_OPERATIONS_PROPOSAL_SUCCESS,
  proposalId,
});

export const CancelNewOperationsProposalError = () => ({
  type: CANCEL_NEW_OPERATIONS_PROPOSAL_ERROR,
});
